import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy
} from '@angular/core';
import { takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { UserLogsService } from 'app/services/user-logs-service/user-logs.service';
import { UserAccessLog } from 'app/models';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { SelectedUserService, UsersService } from 'app/services';
export interface Tab {
  name: string;
  id: number;
}
@Component({
  standalone: false,
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit, OnDestroy {
  public tabs: Tab[] = [];
  public selectedTab: Tab;
  @Input()
  activityLog: any;
  @Input()
  userName: any;
  @Input()
  clientId: any;
  user: any;
  public logs: any;
  public loading: boolean;
  public userId: string;
  userLogsError: any;
  private onDestroy$ = new Subject<void>();
  updateRecords: Subject<boolean> = new Subject();
  currentProfile;
  disableSave: boolean;
  @Output() loader = new EventEmitter();
  appChanges: boolean = false;
  appsValid: boolean = true;
  constructor(
    private readonly _selectedUserService: SelectedUserService,
    private readonly _usersService: UsersService,
    private _userLogsService: UserLogsService,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    private _translateService: TranslateService
  ) {
    this.getTranslate();
  }

  isLoading(event) {
    this.loader.emit(event);
  }

  onChangeTab(tabIndex) {
    this.selectedTab = this.tabs.find(t => t.id === tabIndex);
  }

  getTranslate() {
    this._translateService
      .get('USER_DETAILS.application_access')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => {
        this.tabs.push({ name: value, id: 0 });
      });

    this._translateService
      .get('USER_DETAILS.user_activity')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => {
        this.tabs.push({ name: value, id: 1 });
      });
    this.selectedTab = this.tabs[0];
  }


  ngOnInit() {
    this._usersService.user$.pipe(take(1)).subscribe(res => {
      this.currentProfile = res;
    });

    this._selectedUserService.selectedUser$
    .pipe(takeUntil(this.onDestroy$))
    .subscribe({
      next:(user) => {
        if(user){
          const previousId = this.user?.id ? this.user?.id : this.user?.authID;
          this.user = user;
          this.userId = this.user?.id ? this.user?.id : this.user?.authID;
          this.disableSave = this.user?.id === this.currentProfile?.id;
          if(previousId !== user.id){
            this.getUserLogs();
          }
        }
      },
    });
  }

  ngOnDestroy(): void {
    this._userLogsService.clearSubscription();
    this.onDestroy$.next();
  }

  getUserLogs(): void {
    this.loading = true;
    this._userLogsService.getLogs(this.userId);
    this._userLogsService.userLogs$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((userLogs: UserAccessLog[]) => {
        this.loading = false;
        this.logs = userLogs;
      });
    this._userLogsService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => {
        if (error) {
          this.userLogsError = error;
          this.loading = false;
          this._userLogsService.loadLogs(this.userId);
        }
      });
  }
  
  close() {
    this.dialogRef.close();
  }

  saveData() {
    this.updateRecords.next(true);
  }

  isChanged($event){
    this.appChanges = $event;
  }

  isAppsValid(valid: boolean) {
    this.appsValid = valid;
  }

  isInternalUser(){
    return this.user?.email.toLowerCase().includes('@allegion.com');
  }
}
